import React, {useEffect, useMemo, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import Styles from './index.module.scss'
import NFTModal from "@/components/NFTModal";
import ActivityRules from "../components/ActivityRules";
import {Image, Toast} from "antd-mobile";
import bg4 from '@/assets/img/dunHuang/bg4.jpg'
import bg5 from '@/assets/img/dunHuang/bg5.jpg'
import logo from '@/assets/img/dunHuang/logo.png'
import Service from "../service"
import {hideLoading, showLoading} from "@/components/loading";

/**
 * @description 敦煌藏品
 * @return {/dunHuang/home}
 */
const Btns = [
  { title: '规则', key: 1 }, { title: '实名', key: 2 },
]
const Home = () => {
  const pageDom = useRef(null);
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState({});
  const [data, setData] = useState({});
  const [hasPermission, setHasPermission] = useState(false)
  const [allowNum, setAllowNum] = useState(null)
  const [pageType, setPageType] = useState(0) //页面类型 1优先购 2特权购 3公开购


  useEffect(() => {
    (()=>{
      getData(true);
      onDidFocus();
    })()

  }, []);
  const onDidFocus = () => {
    window.JsBridge.addListener().then(() => {
      getData(true)
      onDidFocus();
    });
  }
  const getData = async (loading = false) => {
    try {
      if (loading) showLoading();
      if (loading) {
        const userInfoRes = await Service.getUserCertificateStatus();
        // const accessRes = await Service.purchasePermissions();
        setUserInfo(userInfoRes);
        // setHasPermission(accessRes.data?.isPermission)
        // setAllowNum(accessRes?.data?.allowNum)
      }
      const res = await Service.getInitData();
      if (loading) hideLoading();
      if (res.code !== '000000') throw res.msg;
      setData(res.data)
      setHasPermission(res.data?.isPermission)
      setPageType(parseInt(res.data?.flag) || 0)
      setAllowNum(res.data?.allowNum)
    } catch (error) {
      hideLoading();
      Toast.show(error);

    }
  }
  const onBack = () => {
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.back();
    } else {
      navigate(-1);
    }
  }
  // 提示信息
  const tipsMessage = useMemo(() => {
    let msg = undefined;
    const { systemTime, startTime, endTime } = data;
    const currentT = new Date(systemTime?.replace(/-/g, "/")).getTime();
    const startT = new Date(startTime?.replace(/-/g, "/")).getTime();
    const endT = new Date(endTime?.replace(/-/g, "/")).getTime();
    if (!startTime || !endTime) {
      msg = "接口异常";
    } else if (currentT < startT) {
      msg = "活动未开始";
    } else if (currentT > endT) {
      msg = "活动已结束";
    }

    return msg;
  }, [data]);
  const buyHandle = () => {
    if(!hasPermission || (allowNum ===0 && (pageType === 1 || pageType === 2))){
      return;
    }
    if (tipsMessage) {
      Toast.show(tipsMessage);
      return;
    }
    if (!userInfo?.ID) {
      Toast.show("请先实名认证");
      return;
    }
    const uri = `/ape/saleDetail?collectionId=${Service.collectionId}&code=${Service.activityCode}`;
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.push("CustomWeb", {
        uri: `${window.location.origin}${uri}`,
      });
    } else {
      navigate(uri);
    }
  }
  const onRightBtnClick = (item) => {
    if (item.key === 1) {
      const ModalInstance = NFTModal.show({
        content: <ActivityRules onClose={() => ModalInstance?.close()} />,
        getContainer: pageDom.current,
      });
    } else if (item.key === 2) {
      window.JsBridge.navigate('Verify');
    }
  }
  return (
    <div className={Styles.dunHuangHome} ref={pageDom}>
      <div className={Styles.back} onClick={onBack}></div>
      <div className={Styles.topCard}>
        <div className={Styles.right_btns}>
          {
            Btns.map((btn, i) => {
              if (btn.key === 2 && userInfo?.ID) return null;
              return (
                <div key={i} className={Styles.rightBtn} onClick={() => onRightBtnClick(btn)}>{btn.title}</div>
              )
            })
          }
        </div>
        <div className={Styles.priorityBuyTab}>
          <div className={`${Styles.tabItem} ${pageType === 1 && Styles.tabActive}`}>
            <div className={Styles.text1}>优先购</div>
            <div className={Styles.text2}>2026/5/15 12:00-</div>
            <div className={Styles.text2}>2026/5/17 11:00</div>
          </div>
          <div className={`${Styles.tabItem} ${pageType === 3 && Styles.tabActive}`}>
            <div className={Styles.text1}>公开购</div>
            <div className={Styles.text2}>2026/5/17 14:00-</div>
            <div className={Styles.text2}>2026/5/20 23:59:59</div>
          </div>
        </div>
        <div className={Styles.nameRow}>
          <div className={Styles.name}/>
        </div>
      </div>
      <div className={Styles.box1}>
        <div className={Styles.luBox}/>
        <img className={Styles.bg3} src={require('@/assets/img/dunHuang/bg3.png')} alt=""/>
        {/* 立即购买按钮 */}
        <button className={Styles.buyBtn} disabled={!hasPermission} onClick={buyHandle} style={{ filter: hasPermission ? 'none' : 'grayscale(1)'}}/>
        {pageType === 1 && (
          <div>
            <span className={Styles.numText1}>剩余可购买数量</span>
            <span className={Styles.numText2}>：{allowNum || 0}</span>
          </div>
        )}
      </div>
      <Image className={Styles.bg4} src={bg4} lazy />
      <Image src={bg5} lazy />
      <div className={Styles.logoBox}>
        <Image  className={Styles.logo} src={logo} lazy />
      </div>
    </div>
  )
}
export default Home